const businessDataKeys = [
  {
    name: "mise_id",
    dataType: "number"
  },
  {
    name: "registration_number",
    dataType: "string"
  },
  {
    name: "business_name",
    dataType: "bool"
  },
  {
    name: "street_address",
    dataType: "string"
  },
  {
    name: "co_address",
    dataType: "string"
  },
  {
    name: "postal_code",
    dataType: "string"
  },
  {
    name: "post_town",
    dataType: "string"
  },
  {
    name: "visit_address",
    dataType: "string"
  },
  {
    name: "visit_address_postal_code",
    dataType: "string"
  },
  {
    name: "visit_address_post_town",
    dataType: "string"
  },
  {
    name: "email",
    dataType: "string"
  },
  {
    name: "webpage",
    dataType: "string"
  },
  {
    name: "phone",
    dataType: "string"
  },
  {
    name: "postal_code",
    dataType: "string"
  },
  {
    name: "post_town",
    dataType: "string"
  },
  {
    name: "industry_code_1",
    dataType: "string"
  },
  {
    name: "industry_code_1_text",
    dataType: "string"
  },
  {
    name: "legal_form_code",
    dataType: "string"
  },
  {
    name: "legal_form_text",
    dataType: "string"
  },
  {
    name: "status",
    dataType: "string"
  },
  {
    name: "registration_date",
    dataType: "string"
  },
  {
    name: "number_of_work_places",
    dataType: "number"
  },
  {
    name: "number_of_employees_code",
    dataType: "string"
  },
  {
    name: "number_of_employees_text",
    dataType: "string"
  },
  {
    name: "sales_code",
    dataType: "string"
  },
  {
    name: "sales_text",
    dataType: "string"
  },
  {
    name: "key_performance_indicator",
    dataType: "object",
    properties: [
      {
        name: "number_of_employees",
        dataType: "number"
      },
      {
        name: "employee_turnover",
        dataType: "number"
      },
      {
        name: "turnover",
        dataType: "number"
      },
      {
        name: "equity_ratio",
        dataType: "number"
      },   
    ]
  },
  {
    name: "decisionmakers_list",
    dataType: "array",
    properties: [
      {
        name: "title",
        dataType: "string"
      },
      {
        name: "first_name",
        dataType: "string"
      },
      {
        name: "last_name",
        dataType: "string"
      },
      {
        name: "email",
        dataType: "string"
      },
      {
        name: "direct_no",
        dataType: "string"
      },   
    ]
  },
  {
    name: "work_places",
    dataType: "array",
    properties: [
      {
        name: "mise_id",
        dataType: "number"
      },
      {
        name: "cfar_no",
        dataType: "number"
      },
      {
        name: "co_address",
        dataType: "string"
      },
      {
        name: "address",
        dataType: "string"
      },
      {
        name: "postal_code",
        dataType: "string"
      },
      {
        name: "post_town",
        dataType: "string"
      },
      {
        name: "visit_address",
        dataType: "string"
      },
      {
        name: "visit_postal_code",
        dataType: "string"
      },
      {
        name: "visit_post_town",
        dataType: "string"
      },
      {
        name: "designation",
        dataType: "string"
      },
      {
        name: "industry_code_1",
        dataType: "string"
      },
      {
        name: "industry_code_1_text",
        dataType: "string"
      },
      {
        name: "phone_no",
        dataType: "string"
      },
      {
        name: "registration_date",
        dataType: "date"
      },
      {
        name: "number_of_employees_code",
        dataType: "string"
      },
      {
        name: "number_of_employees_text",
        dataType: "string"
      },
      {
        name: "type_of_work_place",
        dataType: "string"
      },
    ]
  }
];

export default businessDataKeys;



// WEBPACK FOOTER //
// ./src/data/businessDataKeys.js